import Phaser from 'phaser';
import { MODELS } from '../objects/costume';
import Player, { preload as preloadPlayer } from '../objects/player';
import Coronavirus, { preload as preloadCoronavirus } from '../objects/coronavirus';
import Background, {
  preload as preloadBackground,
} from '../objects/background';
import Ornament, { preload as preloadOrnament } from '../objects/ornament';
import Door, { preload as preloadDoor } from '../objects/door';
import DoorTwo, { preload as preloadDoorTwo } from '../objects/door-two';
import DoorThree from '../objects/door-three';
import { preload as preloadAudio } from '../objects/audio';
import { fadeOutSound } from '../utils';
import { getAssetsUrl } from 'utilities';

import EVENTS from 'constants/EVENTS';
import { 
  landbotHeight,
  groundHeight,
} from '../definitions';

/**
 * Act 2 - Trick or treat.
 */
export default class Act2 extends Phaser.Scene {
  constructor() {
    super({ key: 'Act2', active: false });
  }

  init(data) {
    this.data.set('costume', data.costume);
  }

  preload() {
    this.load.setBaseURL(getAssetsUrl());

    preloadBackground.call(this, 'wall', 'brick_pattern.png');
    preloadBackground.call(this, 'ground', 'ground.png');

    preloadOrnament.call(this, 'pumpkin_2', 'pumpkin_2.png');
    preloadOrnament.call(this, 'light', 'light.png');
    preloadOrnament.call(this, 'candles', 'candles.png');

    preloadPlayer.call(this, this.data.get('costume') || MODELS.MUMMY);
    preloadDoor.call(this);
    preloadDoorTwo.call(this);
    preloadCoronavirus.call(this);

    preloadAudio.call(this, 'knock', 'knock.mp3');
    preloadAudio.call(this, 'music', 'horror_ambience.mp3');
    preloadAudio.call(this, 'storm', 'storm_wind.mp3');
    preloadAudio.call(this, 'door_open', 'open_door.mp3');
    preloadAudio.call(this, 'rat_scream', 'rat_scream.mp3');
    preloadAudio.call(this, 'close_wood', 'close_wood.mp3');
    preloadAudio.call(this, 'close_door', 'close_door.mp3');
    preloadAudio.call(this, 'avalanche', 'avalanche.mp3');
  }

  create() {
    this.cameras.main.setBackgroundColor('#5E4993');
    this.cameras.main.fadeIn(1500);
    this.time.delayedCall(1500, () => {
      __landbot.events.emit('set_visible', true);
    });

    // GAME OBJECTS

    this.wall = new Background(
      this,
      0,
      this.game.config.height,
      this.game.config.width,
      this.game.config.height,
      'wall'
    );

    this.ground = new Background(
      this,
      0,
      this.game.config.height - landbotHeight,
      this.game.config.width,
      20,
      'ground'
    );

    this.firstDoor = new Door(this, 800, this.game.config.height - landbotHeight - groundHeight);

    this.coronavirus = new Coronavirus(this, 800, this.game.config.height - landbotHeight - groundHeight - 80);
    this.coronavirus.setVisible(false);

    const pumpkin_1 = new Ornament(this, 800 + 300, this.game.config.height - landbotHeight - groundHeight, 'pumpkin_2');
    pumpkin_1.setOrigin(0.5, 1);
    pumpkin_1.setScale(0.8);

    const light_1 = new Ornament(this, 800 + 500, this.game.config.height - landbotHeight - groundHeight - 400, 'light');
    light_1.setOrigin(0.5, 1);
    light_1.setScale(0.8);

    this.secondDoor = new DoorTwo(this, 800 + 1200, this.game.config.height - landbotHeight - groundHeight);

    const candles = new Ornament(this, 800 + 1200 + 300, this.game.config.height - landbotHeight - groundHeight, 'candles');
    candles.setOrigin(0.5, 1);
    candles.setScale(0.8);

    const light_2 = new Ornament(this, 800 + 1200 + 500, this.game.config.height - landbotHeight - groundHeight - 400, 'light');
    light_2.setOrigin(0.5, 1);
    light_2.setScale(0.8);
    
    this.thirdDoor = new DoorThree(this, 800 + 1200 + 1200, this.game.config.height - landbotHeight - groundHeight);

    const pumpkin_2 = new Ornament(this, 800 + 1200 + 1200 + 300, this.game.config.height - landbotHeight - groundHeight, 'pumpkin_2');
    pumpkin_2.setOrigin(0.5, 1);
    pumpkin_2.setScale(0.8);

    const light_3 = new Ornament(this, 800 + 1200 + 1200 + 500, this.game.config.height - landbotHeight - groundHeight - 400, 'light');
    light_3.setOrigin(0.5, 1);
    light_3.setScale(0.8);

    this.player = new Player(this, 0, this.game.config.height - landbotHeight - groundHeight - 5);
    this.player.setOrigin(0.5, 1);
    this.player.setScale(0.8);

    this.audio = {
      background: this.sound.add('music', {
        volume: 0.2,
        loop: true,
      }),
      // storm: this.sound.add('storm', {
      //   volume: 0.3,
      //   loop: true,
      // }),
      // close_wood: this.sound.add('close_wood', {
      //   volume: 0.8,
      // }),
      knock: this.sound.add('knock', {
        volume: 0.6,
      }),
      door_open: this.sound.add('door_open', {
        volume: 0.2,
      }),
      rat_scream: this.sound.add('rat_scream', {
        volume: 0.3,
        loop: true,
      }),
      close_wood: this.sound.add('close_wood', {
        volume: 0.7,
      }),
      close_door: this.sound.add('close_door', {
        volume: 0.7,
      }),
      avalanche: this.sound.add('avalanche', {
        volume: 0.5,
      }),
      // poof: this.sound.add('poof'),
    };

    // PHYSICS

    this.physics.world.setBounds(
      0,
      0,
      1200 * 5,
      this.game.config.height
    );
    this.physics.world.setBoundsCollision(true);

    this.physics.add.existing(this.ground);
    this.ground.body.setSize(1200 * 5, 20);
    this.ground.body.setAllowGravity(false);
    this.ground.body.immovable = true;

    this.physics.add.existing(this.firstDoor);
    this.firstDoor.body.setAllowGravity(false);
    this.firstDoor.body.immovable = true;

    this.physics.add.existing(this.secondDoor);
    this.secondDoor.body.setAllowGravity(false);
    this.secondDoor.body.immovable = true;

    this.physics.add.existing(this.thirdDoor);
    this.thirdDoor.body.setAllowGravity(false);
    this.thirdDoor.body.immovable = true;

    this.player.body.setCollideWorldBounds(true);

    this.physics.add.collider(this.player, this.ground);

    // SCRIPT

    this.audio.background.play();

    this.cameras.main.setBounds(
      0,
      0,
      1200 * 5,
      this.game.config.height
    );
    this.cameras.main.startFollow(this.player);

    this.firstDoorEncounter = this.physics.add.overlap(
      this.player,
      this.firstDoor,
      firstDoorEncounter.bind(this),
      null,
      this
    );

    this.secondDoorEncounter = this.physics.add.overlap(
      this.player,
      this.secondDoor,
      secondDoorEncounter.bind(this),
      null,
      this
    );

    this.thirdDoorEncounter = this.physics.add.overlap(
      this.player,
      this.thirdDoor,
      thirdDoorEncounter.bind(this),
      null,
      this
    );

    __landbot.events.on(EVENTS.PLAYER_MOVE, () => {
      this.player.move();
    });
  }

  update() {
    this.wall.tilePositionX = this.cameras.main.scrollX * 1;
  }
}

function firstDoorEncounter() {
  this.physics.world.removeCollider(this.firstDoorEncounter);
  this.player.stop();
  __landbot.events.emit(EVENTS.SEND_MESSAGE, {
    message: 'DOOR_ONE_IN',
  });

  __landbot.events.once(EVENTS.FIRST_DOOR_ENCOUNTER, () => {
    this.tweens.timeline({
      targets: this.player,
      tweens: [
        {
          alpha: 1,
          duration: 2500,
          onStart: () => {
            this.firstDoor.knock();
          },
        },
        {
          alpha: 1,
          duration: 2000,
          onStart: () => {
            this.audio.door_open.play();
          },
        },
        {
          alpha: 1,
          duration: 2000,
          onStart: () => {
            this.firstDoor.open(true);
            this.coronavirus.setVisible(true);
            this.audio.rat_scream.play();
            this.cameras.main.shake(4000, 0.005);
            __landbot.events.emit(EVENTS.SEND_MESSAGE, {
              message: 'DOOR_ONE_OUT',
            });
          },
        },
        {
          alpha: 1,
          duration: 1000,
          onStart: () => {
            this.coronavirus.spread();
          },
        },
      ],
    });
  });

  __landbot.events.once(EVENTS.FIRST_DOOR_CLOSE, () => {
    this.tweens.timeline({
      targets: this.player,
      tweens: [
        {
          alpha: 1, 
          duration: 3000,
          onStart: () => {
            this.coronavirus.stopSpread();
            this.coronavirus.setVisible(false);
            this.audio.rat_scream.stop();
            this.firstDoor.close();
            this.audio.close_door.play();
          },
        }
      ],
    });
  });
}

function secondDoorEncounter() {
  this.physics.world.removeCollider(this.secondDoorEncounter);
  this.player.stop();
  __landbot.events.emit(EVENTS.SEND_MESSAGE, {
    message: 'DOOR_TWO_IN',
  });

  __landbot.events.once(EVENTS.SECOND_DOOR_ENCOUNTER, () => {
    this.tweens.timeline({
      targets: this.player,
      tweens: [
        {
          alpha: 1,
          duration: 3000,
          onStart: () => {
            this.secondDoor.knock();
          },
        },
        {
          alpha: 1,
          duration: 9000,
          onStart: () => {
            this.secondDoor.open();
          },
        },
        {
          alpha: 1,
          duration: 1000,
          onStart: () => {
            this.secondDoor.close();
            this.audio.close_wood.play();
            __landbot.events.emit(EVENTS.SEND_MESSAGE, {
              message: 'DOOR_TWO_OUT',
            });
          },
        },
      ],
    });
  });
}

function thirdDoorEncounter() {
  this.physics.world.removeCollider(this.thirdDoorEncounter);
  this.player.stop();
  __landbot.events.emit(EVENTS.SEND_MESSAGE, {
    message: 'DOOR_THREE_IN',
  });

  __landbot.events.once(EVENTS.THIRD_DOOR_ENCOUNTER, () => {
    this.tweens.timeline({
      targets: this.player,
      tweens: [
        {
          alpha: 1,
          duration: 2000,
          onStart: () => {
            this.thirdDoor.knock();
          },
        },
        {
          alpha: 1,
          duration: 500,
          onStart: () => {
            this.thirdDoor.open();
            this.player.move({ speed: 40 });
          },
        },
        {
          alpha: 1,
          duration: 1000,
          onStart: () => {
            __landbot.events.emit(EVENTS.SET_VISIBLE, false);
            this.cameras.main.fadeOut(1500);
            fadeOutSound.call(this, this.audio.background, 1500);
            this.time.delayedCall(1500, () => {
              __landbot.events.emit(EVENTS.ACT_3);
              this.scene.start('Act3', {
                costume: this.data.get('costume'),
              });
            });
          },
        },
      ],
    });
  });
}